// extracted by mini-css-extract-plugin
export var auto = "_25-1";
export var spinner = "_25-0";